import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/anim";
import api from "@/lib/api";

function formatDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
  } catch {
    return "";
  }
}

export default function NewsPreview() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/news").then(({ data }) => setItems(data.slice(0, 4))).catch(() => {});
  }, []);

  return (
    <section id="news" data-testid="news-preview-section" className="bg-bg-primary py-28 md:py-40">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
            <div>
              <p className="text-brand-teal text-xs font-bold uppercase tracking-[0.25em] mb-4">Newsroom</p>
              <h2 className="font-heading text-4xl md:text-6xl font-medium tracking-tight text-ink leading-none">
                Latest from US Desalination.
              </h2>
            </div>
            <Link
              to="/news"
              data-testid="view-all-news"
              className="hover-underline text-brand-navy font-semibold text-sm flex items-center gap-1"
            >
              View all news <ArrowUpRight size={16} />
            </Link>
          </div>
        </Reveal>

        <div className="mt-14">
          {items.length === 0 && <p className="text-ink-soft border-t border-brand-navy/15 py-10">No articles yet.</p>}
          {items.map((n, i) => (
            <Reveal key={n._id} delay={i * 0.05}>
              <Link
                to={`/news/${n.slug}`}
                data-testid={`news-item-${i}`}
                className="group grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 items-start border-t border-brand-navy/15 py-8 md:py-10"
              >
                <div className="md:col-span-3">
                  <span className="text-xs uppercase tracking-[0.15em] text-brand-red font-semibold">{n.category}</span>
                  <p className="text-ink-soft text-sm mt-1">{formatDate(n.published_at)}</p>
                </div>
                <div className="md:col-span-8">
                  <h3 className="font-heading text-2xl md:text-3xl text-ink leading-tight tracking-tight group-hover:text-brand-navy transition-colors">
                    {n.title}
                  </h3>
                  <p className="mt-3 text-ink-soft text-base leading-relaxed line-clamp-2">{n.excerpt}</p>
                </div>
                <div className="md:col-span-1 flex md:justify-end">
                  <ArrowUpRight className="text-brand-navy transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
                </div>
              </Link>
            </Reveal>
          ))}
          <div className="border-t border-brand-navy/15" />
        </div>
      </div>
    </section>
  );
}
